<template>
  <div class="cashier-state-screen">
    <div class="cashier-state-shell">
      <div class="cashier-state-card cashier-state-card--loading cashier-state-card--compact">
        <div class="cashier-state-mark">
          <span class="cashier-state-spinner"></span>
        </div>
        <div class="cashier-state-eyebrow">支付处理中</div>
        <h1 class="cashier-state-title">正在打开支付页面</h1>
        <div class="cashier-state-copy">请稍候，系统正在为您准备支付信息。</div>
      </div>
    </div>
  </div>
</template>

<script>
// 分发器页面，用户扫码后进入的第一个页面：
// 判断支付环境，PC端显示二维码，移动端跳转到支付方式选择页面
export default {
  components: {
  },

  mounted() {
    const that = this;

    // 直接跳转到统一收银台页面
    that.$router.push({name: 'CashierHome'})

  }


}
</script>
<style lang="css" scoped>
@import './cashier-desktop.css';
</style>
